const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIconInverse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 650 689",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.998062,-237.696,-653.948)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.07054,0,0,1,-1208.15,-240.434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1957.21,960.402C1957.21,924.666 1930.16,895.652 1896.84,895.652L1410.94,895.652C1377.62,895.652 1350.58,924.666 1350.58,960.402L1350.58,1520.47C1350.58,1556.2 1377.62,1585.22 1410.94,1585.22L1896.84,1585.22C1930.16,1585.22 1957.21,1556.2 1957.21,1520.47L1957.21,960.402Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1091.11,-330.967)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1486,
    cy: 1091.02,
    r: 41.434,
    style: {
      fill: "rgb(84,32,217)",
      fillOpacity: 0.24
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-757.284,-330.967)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1486,
    cy: 1091.02,
    r: 41.434,
    style: {
      fill: "rgb(84,32,217)",
      fillOpacity: 0.24
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.347781,-0.348225,0.348225,-0.347781,520.285,1479.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1240.58,826.367C1169.78,755.561 1073.75,715.783 973.612,715.783C765.233,715.783 596.057,884.96 596.057,1093.34C596.057,1193.47 635.835,1289.51 706.64,1360.31L761.261,1305.69C704.943,1249.37 673.303,1172.99 673.303,1093.34C673.303,927.593 807.867,793.03 973.612,793.03C1053.26,793.03 1129.64,824.669 1185.96,880.988L1240.58,826.367Z",
    style: {
      fill: "rgb(84,32,217)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconInverse);
export default __webpack_public_path__ + "static/media/logo-icon-inverse.32de78266809598ea934f68b47b312ab.svg";
export { ForwardRef as ReactComponent };